import React, { useState, useEffect } from 'react';
import { getGoogleDriveImageUrl } from '../utils/imageUtils.ts';

interface ImageWithFallbackProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    fallbackSrc?: string;
    hideOnError?: boolean;
}

const ImageWithFallback: React.FC<ImageWithFallbackProps> = ({ 
    src, 
    fallbackSrc = '/placeholder.png',
    hideOnError = true,
    alt = '',
    ...props 
}) => {
    const [imgSrc, setImgSrc] = useState<string>('');
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        const processedSrc = getGoogleDriveImageUrl(src || '');
        setImgSrc(processedSrc);
        setHasError(false);
    }, [src]);

    const handleError = () => {
        if (!hasError) {
            setHasError(true);
            if (!hideOnError) {
                setImgSrc(fallbackSrc);
            }
        }
    };

    if (hasError && hideOnError) {
        return null;
    }

    return (
        <img
            src={imgSrc}
            alt={alt}
            onError={handleError}
            {...props}
        />
    );
};

export default ImageWithFallback; 